import { useTranslation } from 'react-i18next'
import { roundPrice } from 'utils/functions'
import { PROMOCODE_TYPES } from 'utils/constants'

const OrderSummary = ({
  subTotalAmount,
  otherPaymentAmount,
  totalAmount,
  freeItemsSum,
  promocodeDiscountSum,
  deliveryCost,
  orderPromocode,
  orderWalletDiscount,
  redeemLoyaltyAmount,
  isPartialPayment,
  otherPaymentMethod,
}) => {
  const { t } = useTranslation()

  const totalWalletNum = Number(orderWalletDiscount) || 0
  const loyaltyAmountNum = Number(redeemLoyaltyAmount) || 0
  const walletAmountNum = totalWalletNum - loyaltyAmountNum
  const onlyLoyaltyUsed = loyaltyAmountNum > 0 && totalWalletNum === loyaltyAmountNum
  const showWalletRow = totalWalletNum > 0 || loyaltyAmountNum > 0

  return (
    <div className="orderSummary">
      <div className="orderSummary-info">
        <div className="orderSummary-item">
          <div className="orderSummary-title">{t('orders.amount')}</div>
          <div className="orderSummary-value">
            {roundPrice(totalAmount)}
            &nbsp;
            {t('app.currency')}
          </div>
        </div>
        <div className="orderSummary-item">
          <div className="orderSummary-title">{t('orders.discount')}</div>
          <div className="orderSummary-value">
            {freeItemsSum ? roundPrice(freeItemsSum) : 0}
            &nbsp;
            {t('app.currency')}
          </div>
        </div>
        {!onlyLoyaltyUsed && walletAmountNum > 0 && (
          <div className="orderSummary-item">
            <div className="orderSummary-title">{t('orders.walletDiscount')}</div>
            <div className="orderSummary-value">
              {roundPrice(walletAmountNum)}
              &nbsp;
              {t('app.currency')}
            </div>
          </div>
        )}
        {loyaltyAmountNum > 0 && (
          <div className="orderSummary-item">
            <div className="orderSummary-title">{t('orders.loyalty redeemed')}</div>
            <div className="orderSummary-value">
              {roundPrice(loyaltyAmountNum)}
              &nbsp;
              {t('app.currency')}
            </div>
          </div>
        )}
        <div className="orderSummary-item">
          <div className="orderSummary-title">
            {t('orders.promocode')}
            &nbsp;
            {orderPromocode?.discountType === PROMOCODE_TYPES.PERCENT.KEY && (
              <span style={{ color: '#808898' }}>({orderPromocode.discountQuantity}%)</span>
            )}
          </div>
          <div className="orderSummary-value">
            {roundPrice(promocodeDiscountSum)}
            &nbsp;
            {t('app.currency')}
          </div>
        </div>
        <div className="orderSummary-item">
          <div className="orderSummary-title">{t('orders.delivery price')}</div>
          <div className="orderSummary-value">
            {roundPrice(deliveryCost)}
            &nbsp;
            {t('app.currency')}
          </div>
        </div>
        {isPartialPayment && Number(subTotalAmount) > 0 && (
          <div className="orderSummary-item">
            <div className="orderSummary-title">
              {t('orders.paid by')}
              {otherPaymentMethod && (
                <span
                  style={{
                    marginLeft: '6px',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    background: '#E8F1FF',
                    color: '#1A6FE0',
                    fontSize: '11px',
                    fontWeight: 600,
                    letterSpacing: '0.3px',
                  }}
                >
                  {otherPaymentMethod}
                </span>
              )}
            </div>
            <div className="orderSummary-value">
              {roundPrice(otherPaymentAmount)}
              &nbsp;
              {t('app.currency')}
            </div>
          </div>
        )}
      </div>
      <div className="orderSummary-main">
        <div className="orderSummary-item">
          <div className="orderSummary-title">{t('orders.total')}</div>
          <div className="orderSummary-value">
            {roundPrice(subTotalAmount)}
            &nbsp;
            {t('app.currency')}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderSummary
